import { gql, useMutation } from "@apollo/client";

export const MUTATION_IMPORT_CDL = gql`
  mutation importCdlData(
    $cdlPaths: [String!]!
    $targetFolder: String!
    $activityId: ID!
    $qualityCheckStatus: QualityCheckStatus
    $description: String
  ) {
    importCdlData(
      input: {
        cdlPaths: $cdlPaths
        targetFolder: $targetFolder
        activityId: $activityId
        qualityCheckStatus: $qualityCheckStatus
        description: $description
      }
    )
  }
`;

export function useImportCdl() {
  const [
    importCdlContentMutation,
    {
      data: cdlImportMutationData,
      loading: isLoadingCdlMutation,
      error: errorCdlMutation
    }
  ] = useMutation(MUTATION_IMPORT_CDL, {
    onError(err: any) {
      console.log(err);
    }
  });

  return {
    importCdlContentMutation,
    cdlImportMutationData,
    isLoadingCdlMutation,
    errorCdlMutation
  };
}
